import styled from 'styled-components';

export const PanelPaginationRow = styled.div.attrs({
  className: 'bdm-panel-pagination-row',
})`
  padding: 0;
`;

export default PanelPaginationRow;
